/**
* Blog Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Blog Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'blog-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.blog-card-slider-wrapper' ).slick( {
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        appendArrows: $( '.blog-card-slider-nav-wrapper' ),
        nextArrow: '<div class="icon-wrapper next flex items-center justify-center cursor-pointer pl-4"><svg class=" hover:bg-brand-ice icon icon-arrow-right text-brand-charcoal border border-brand-charcoal rounded-full h-10 w-10"><use xlink:href="#icon-arrow-right"></use></svg></div>',
        prevArrow: '<div class="icon-wrapper prev flex items-center justify-center cursor-pointer pr-4"><svg class=" hover:bg-brand-ice icon icon-arrow-right text-brand-charcoal border border-brand-charcoal rounded-full h-10 w-10"><use xlink:href="#icon-arrow-right"></use></svg></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              centerPadding: '0px',
              initialSlide: 0,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'blog-card-slider', COMPONENT );
} )( app );
